import { callTokenApi } from '../apiCaller';
import { API_AI_INSIGHTS_AVAILABLE_REPORTS } from '../constants/apiRest';

/**
 * Option label for a saved report in the AI Insight data source picker.
 * Cross-account reports are prefixed with their account name because report names
 * collide across accounts.
 */
export const buildReportOptionLabel = ({ name, accountName, isCrossAccount }) => {
    if (!isCrossAccount || !accountName) {
        return name;
    }
    return `${accountName} - ${name}`;
};

/**
 * Rolling-date-range saved reports selectable as data sources for a template:
 * the account's own reports plus any allowlisted accounts' reports.
 *
 * `onError` (optional, defaults to a no-op) is invoked on every failure path
 * before the empty array is returned, so callers can surface a message to the
 * user instead of silently rendering an empty dropdown.
 */
export const fetchAiInsightAvailableReports = async ({ templateId, accountId, userId, onError = () => {} }) => {
    try {
        const url = `${API_AI_INSIGHTS_AVAILABLE_REPORTS.replace(':templateId', templateId)}?accountId=${accountId}&userId=${userId}`;
        const response = await callTokenApi(url, 'GET');

        if (response?.status === 200) {
            const reportViews = response.data?.reportViews;

            if (!Array.isArray(reportViews)) {
                onError(new Error('Available reports response did not include reportViews.'));
                return [];
            }

            return reportViews;
        }

        onError(new Error(`Failed to load available reports (status ${response?.status}).`));
        return [];
    } catch (error) {
        onError(error);
        return [];
    }
};
